if (!customElements.get("footer-section")) {
  customElements.define(
    "footer-section",
    class FooterSection extends HTMLElement {
      constructor() {
        super();
      }
      toggleMenu(event) {
        const button = event.currentTarget;
        const container = button.parentElement;
        const content = container?.querySelector("[data-footer-menu-link-content]");
        const icon = button.querySelector("svg");
        if (content) {
          content.classList.toggle("opacity-0");
          content.classList.toggle("h-0");
          content.classList.toggle("overflow-hidden");
        }
        if (icon) {
          icon.classList.toggle("rotate-90");
          icon.classList.toggle("-rotate-90");
        }
        const isExpanded = button.getAttribute("aria-expanded") === "true";
        button.setAttribute("aria-expanded", String(!isExpanded));
      }
      setupToggleButtons() {
        const toggleButtons = this.querySelectorAll("[data-footer-menu-link-toggle]");
        toggleButtons.forEach((button) => {
          button.addEventListener("click", this.toggleMenu.bind(this));
        });
      }
      init() {
        this.setupToggleButtons();
      }
      // Lifecycle callback when the element is connected to the DOM
      connectedCallback() {
        this.init();
      }
    }
  );
}
